import React from 'react';
import styles from '../DescriptionEditor.module.scss';
import { LinkIcon, TextLinesIcon } from './Icons';

/**
 * Inputs + Apply/Cancel row shared by the dock portal and the mobile
 * inline/fixed toolbar. Knows nothing about anchoring or portaling — just
 * renders the form and delegates to the parent via props.
 */
export default function LinkPanel({
  selectionEmpty,
  linkUrl,
  linkText,
  setLinkUrl,
  setLinkText,
  linkUrlInputRef,
  linkTextInputRef,
  linkBlurProps,
  canApplyLink,
  applyLink,
  cancelLinkMode,
}) {
  const urlKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (canApplyLink) applyLink();
    }
    if (e.key === 'Escape') {
      e.preventDefault();
      cancelLinkMode();
    }
  };

  const urlInput = (
    <div className={styles.chromeLinkInputShell}>
      <span className={styles.chromeLinkFieldIconWrap} aria-hidden>
        <LinkIcon />
      </span>
      <input
        ref={linkUrlInputRef}
        className={styles.chromeLinkInputInner}
        type="url"
        inputMode="url"
        value={linkUrl}
        onChange={(e) => setLinkUrl(e.target.value)}
        placeholder="Type or paste a link"
        autoComplete="url"
        aria-label="Link URL"
        {...linkBlurProps}
        onKeyDown={urlKeyDown}
      />
    </div>
  );

  return (
    <>
      <div className={styles.chromeLinkPanelStack}>
        {selectionEmpty && (
          <div className={styles.chromeLinkInputShell}>
            <span className={styles.chromeLinkFieldIconWrap} aria-hidden>
              <TextLinesIcon />
            </span>
            <input
              ref={linkTextInputRef}
              className={styles.chromeLinkInputInner}
              type="text"
              value={linkText}
              onChange={(e) => setLinkText(e.target.value)}
              placeholder="Text"
              autoComplete="off"
              aria-label="Link text"
              {...linkBlurProps}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  linkUrlInputRef.current?.focus();
                }
                if (e.key === 'Escape') {
                  e.preventDefault();
                  cancelLinkMode();
                }
              }}
            />
          </div>
        )}
        {urlInput}
      </div>
      <div className={styles.chromeLinkPanelActions}>
        <button
          type="button"
          className={styles.chromeApplyBtn}
          disabled={!canApplyLink}
          onMouseDown={(e) => {
            e.preventDefault();
            if (canApplyLink) applyLink();
          }}
          aria-label="Apply link"
        >
          Apply
        </button>
        <button
          type="button"
          className={styles.chromeCancelBtn}
          onMouseDown={(e) => {
            e.preventDefault();
            cancelLinkMode();
          }}
          aria-label="Cancel"
        >
          Cancel
        </button>
      </div>
    </>
  );
}
